import { Box, styled } from '@mui/material';

export const StyledTestingEditorBox = styled(Box)`
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 10px;
`;
export const StyledTestingConfigurationBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 20px;
    justify-content: space-around;
`;
export const StyledTestingSelectBox = styled(Box)`
    width: 350px;
    display: flex;
    flex-direction: row;
    align-items: center;

    & .rules-list-field {
        width: 100%;
    }

    & .outputs-field {
        width: 100%;
    }
`;
export const StyledTestingInputsDataBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 20px;
    justify-content: space-around;
`;
export const StyledDisplayInputsBox = styled(Box)`
    & .inputs-field-buttons {
        margin: 10px;
    }

    & .input-field-button {
        color: white;
        border: 1px solid #006ebb;
        margin-right: 5px;
    }
`;
